export default function doctorMode(block) {
  if (block && ['auto', 'manual', 'disabled'].includes(block.mode)) return block.mode
  if (block && block.enabled === true) return 'manual'
  if (block && Array.isArray(block.ids) && block.ids.length) return 'disabled'
  return 'auto'
}
